// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3_Jgg","head":"ProcedureTableInfo_head__Xyo6N"};